import { render } from "./ArticleCard.vue?vue&type=template&id=51dd7a50&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=51dd7a50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd7a50"]])

export default __exports__